import { createUseStyles } from 'react-jss'
import { green, lightGreen, lightGrey, trafficRedDark } from '../../../styles/const/colors'

const getBtnBackgroundColor = ({ success, error }) => {
  if (success) {
    // success button state
    return lightGreen
  } else if (error) {
    // error button state
    return trafficRedDark
  }
}
export default createUseStyles(theme => ({
  test: {
    marginBottom: 16
  },
  pbContainer: {
    display: 'inline-block',
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden'
  },
  pbButton: {
    // show default button background color during loading
    borderColor: lightGrey,
    backgroundColor: ({ success, error }) =>
      (success || error) && [getBtnBackgroundColor({ success, error }), '!important'],
    textDecoration: 'none',
    textAlign: 'center',
    '-webkit-tap-highlight-color': 'transparent',
    outline: 'none',
    position: 'relative',

    '& .loader': {
      maxHeight: '80%',
      position: 'absolute',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      top: '50%',
      '& .path': {
        stroke: [theme.brandPrimary, '!important'],
        animation: '$dash 1.5s ease-in-out infinite, $color 6s ease-in-out infinite'
      }
    },

    '@global': {
      span: {
        display: 'inherit',
        transition: 'opacity 0.3s 0.1s',
        fontSize: '2em',
        fontWeight: 100
      },
      svg: {
        pointerEvents: 'none'
      },
      'svg path': {
        opacity: 0,
        fill: 'none'
      },
      '.pb-checkmark > path, .pb-cross > path': {
        opacity: ({ success, error }) => (success || error) && 1
      },
      'svg.pb-checkmark path, svg.pb-cross path': {
        strokeLinecap: 'round',
        strokeWidth: 4
      },
      'svg.pb-checkmark path': {
        stroke: green
      },
      'svg.pb-cross path': {
        stroke: '#fff'
      }
    }
  },
  icon: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    height: 46,
    width: 46
  },
  text: {
    transition: 'all 0.15s'
  },

  '@keyframes dash': {
    '0%': {
      strokeDasharray: '1, 200',
      strokeDashoffset: '0'
    },
    '50%': {
      strokeDasharray: '89, 200',
      strokeDashoffset: '-35px'
    },
    '100%': {
      strokeDasharray: '89, 200',
      strokeDashoffset: '-124px'
    }
  },

  '@keyframes color': {
    '0%, 100%': { stroke: 'white' },
    '40%': { stroke: 'white' },
    '66%': { stroke: 'white' },
    '80%, 90%': { stroke: 'white' }
  }
}))
